var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"title is-4"},[_vm._v(" "+_vm._s(_vm.account.subscription.plan.title)+" "),_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.isAnnual ? 'Annual' : 'Monthly'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }